module.exports = __webpack_public_path__ + "media/img/frontend_application/bottomnav/favourite-f3c9aa78f9ec79044a1afe2193292bb7.svg";